module.exports = __webpack_public_path__ + "img/image-half-oval.8f9762e.jpg";